import { phoneNumberRegex, phoneСodeCountryRegex } from '../constants';

export function emailRegexValidation(email) {
  const emailRegex = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
  return emailRegex.test(email);
}

export const passwordValidation = password => !!password && password.length >= 6 && password.length <= 20;

export const phoneRegexValidation = phone => phoneNumberRegex.test(phone);
export const phoneCodeCountyRegexValidation = phone => phoneСodeCountryRegex.test(phone);

export const licenseNumberValidation = (license = '') => license.length >= 4 && license.length <= 9;

export const companyNameValidation = (companyName = '') => !!companyName.length;

export const validateAuthPhoneNumber = (phoneNumber = '') => {
  const number = phoneNumber.toString().replace(/\D/g, '');
  const isValid = !!number && number.length >= 9 && number.length <= 15;
  return !isValid;
};


export const validatePhoneWithSeparateCountryCode = (phoneNumber, countryCode = '') => {
  if (!phoneNumber) {
    return 'Required';
  }

  if (!phoneRegexValidation(phoneNumber)) {
    return 'Required';
  }

  const formattedCountryCode = (!countryCode.length || countryCode.startsWith('+')) ? countryCode : `+${countryCode}`;
  const phoneWithoutCode = phoneNumber.slice(formattedCountryCode.length);

  if (!phoneWithoutCode.length) {
    return 'Required';
  }

  const isInvalid = validateAuthPhoneNumber(phoneWithoutCode);

  if (isInvalid) {
    return 'phone-number';
  }

  return undefined;
};
